import API from "./api";
import { OpenInNewModalSVG } from "./icons";
import { ShowProposalSubmitting, ShowProposalSuccess } from "./snackbar";
import OpenDialog from "./dialog";
import OpenErrorDialog from "./dialog_error";

const Challenges = () => window.map_data["Challenges"].map( p => p.Title );

const truncate = (input, len) => {
    if (input.length > len) {
        return input.substring(0, len).trim() + "...";
    }
    return input;
};

export default class extends HTMLElement {
    #button = null;
    #term = "";

    connectedCallback () {
        this.#term = this.attributes.term.value;
        this.innerHTML = `
            <button>
                <span>Propose a challenge relationship to this harm</span>
                ${OpenInNewModalSVG}
            </button>
        `;
        this.#button = this.querySelector("button");

        this.#button.addEventListener("click", async (e) => {
            e.preventDefault();
            this.openDialog();
        }); 
    }

    openDialog () {
        const selectList = document.createElement("select");
        selectList.required = true;
        selectList.name = "challenge";

        const option = document.createElement("option");
        option.value = "";
        option.text = "New challenge relation";
        selectList.appendChild(option);

        Challenges().forEach(challenge => {
            const option = document.createElement("option");
            option.value = challenge;
            option.text = truncate(challenge, 120);
            option.title = challenge;
            selectList.appendChild(option);
        });

        const el = document.createElement("div");
        el.innerHTML = `
            <form id="propose-resource-form" method="dialog">
                ${selectList.outerHTML}
                <textarea required placeholder="General reasoning. How is this relationship appropriate?" name="reasoning"></textarea>
                <button type="submit" value="confirm">Propose relationship</button>
            </form>
        `;

        const dialog = OpenDialog("Propose a new challenge relationship to this harm", el.innerHTML);

        const handler = async (e) => { 
            dialog.removeEventListener("close", handler);
            if (e.target.returnValue !== "confirm") {
                return;
            }
            e.target.returnValue = "";
            const form = e.target.querySelector("form#propose-resource-form");

            const formData = new FormData(form);

            ShowProposalSubmitting();

            const response = await API.proposeChallengeRelationshipToHarm(
                formData.get("challenge"),
                this.#term,
                formData.get("reasoning"),
            );

            if (response.ok) {
                ShowProposalSuccess();
            } else {
                const errorData = await response.json();
                OpenErrorDialog(errorData);
                return;
            }

            return false;
        };

        dialog.addEventListener("close", handler);
    }
}
